import { useState, useRef, useEffect } from "react";

const languages = [
  // { code: 'cn', label: '简体中文', img: '/assets/images/icon/lang-china.png' },
  // { code: 'en', label: 'English', img: '/assets/images/icon/lang-usa.png' },
  // { code: 'br', label: 'Brazil', img: '/assets/images/icon/lang-brazil.png' },
  // { code: 'ca', label: 'Canada', img: '/assets/images/icon/lang-canada.png' },
  // { code: 'fr', label: 'France', img: '/assets/images/icon/lang-france.png' },
  // { code: 'it', label: 'Italy', img: '/assets/images/icon/lang-italy.png' },

  { code: "en", label: "English", img: "/assets/images/icon/lang-usa.png" },
  { code: "zh", label: "简体中文", img: "/assets/images/icon/lang-china.png" },
  { code: "es", label: "Español", img: "/assets/images/icon/lang-brazil.png" },
  { code: "ru", label: "Русский", img: "/assets/images/icon/lang-canada.png" },
  { code: "fr", label: "Français", img: "/assets/images/icon/lang-france.png" },
];

const HeaderLanguageSelect = () => {
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const langDropdownRef = useRef(null);
  const [isTriggerHovered, setIsTriggerHovered] = useState(false);
  const [hoveredLangCode, setHoveredLangCode] = useState("");

  // Load saved language from localStorage or default to English
  const [selectedLang, setSelectedLang] = useState(() => {
    const savedCode = localStorage.getItem("lng");
    return languages.find((lang) => lang.code === savedCode) || languages[0]; // default to EN
  });

  const handleLanguageChange = (langCode) => {
    setShowLanguageMenu(false);
    if (langCode === selectedLang.code) return;
    const selected = languages.find((lang) => lang.code === langCode);
    if (selected) {
      setSelectedLang(selected);
      localStorage.setItem("lng", langCode);
      console.log(`Language changed to: ${selected.label}`);
    }
  };

  // const [selectedLang, setSelectedLang] = useState(languages[1]); // default EN

  // const handleLanguageChange = (langCode) => {
  //     setShowLanguageMenu(false);
  //     if (langCode === selectedLang.code) return;
  //     const selected = languages.find(lang => lang.code === langCode);
  //     if (selected) {
  //         setSelectedLang(selected);
  //         console.log(`Language changed to: ${selected.label}`);
  //     }
  // };

  const handleClickOutside = (event) => {
    if (
      langDropdownRef.current &&
      !langDropdownRef.current.contains(event.target)
    ) {
      setShowLanguageMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="language-area">
      <div className="translate_wrapper" ref={langDropdownRef}>
        <div className="current_lang">
          <div
            className="lang d-flex align-items-center gap-2"
            onClick={() => setShowLanguageMenu(!showLanguageMenu)}
            onMouseEnter={() => setIsTriggerHovered(true)}
            onMouseLeave={() => setIsTriggerHovered(false)}
            style={{
              cursor: "pointer",
              border: "1px solid transparent",
              backgroundColor: isTriggerHovered
                ? "rgba(var(--g1), 0.12)"
                : "transparent",
              borderColor: isTriggerHovered
                ? "rgba(53, 195, 30, 0.5)"
                : "transparent",
              boxShadow: isTriggerHovered
                ? "rgba(0, 0, 0, 0.18) 0 6px 16px"
                : "none",
              transform: isTriggerHovered ? "translateY(-1px)" : "none",
            }}
          >
            <img className="rounded-5" src={selectedLang.img} alt="icon" />
            <span className="lang-txt">{selectedLang.code}</span>
            <i
              className="ti ti-arrow-badge-down-filled fs-five n5-color respon-icon"
              style={{
                display: "inline-block",
                transition: "transform 0.25s ease, color 0.25s ease",
                transform: showLanguageMenu ? "rotate(180deg)" : "rotate(0deg)",
              }}
            ></i>
          </div>
        </div>
        <div className={`more_lang${showLanguageMenu ? ".active" : ""}`}>
          {languages.map((lang) => (
            <div
              className="lang"
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              onMouseEnter={() => setHoveredLangCode(lang.code)}
              onMouseLeave={() => setHoveredLangCode("")}
              style={{
                cursor: "pointer",
                border: "1px solid transparent",
                backgroundColor:
                  hoveredLangCode === lang.code
                    ? "rgb(var(--p3))"
                    : "transparent",
                borderColor:
                  hoveredLangCode === lang.code
                    ? "rgba(53, 195, 30, 0.45)"
                    : "transparent",
                boxShadow:
                  hoveredLangCode === lang.code
                    ? "rgba(0, 0, 0, 0.22) 0 8px 18px"
                    : "none",
                transform:
                  hoveredLangCode === lang.code ? "translateY(-1px)" : "none",
              }}
            >
              <img className="rounded-5" src={lang.img} alt={lang.label} />
              <span className="lang-txt">{lang.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeaderLanguageSelect;
